import React, { Component } from 'react'
import { connect } from 'react-redux'

import classNames from './UpdateKeywordVisibility.css'
import { updateGraphNodes, touchNodeWeighting } from '../redux/keywords'
import KeywordGraphPicker, { ExamplePercentage, ExamplePercentageGroup } from '../components/KeywordGraphPicker'

class UpdateKeywordWeighting extends Component {
  state = {
    updatedNodes: {},
    saving: false
  }
  updateNodes = updatedNodes => {
    this.setState({ updatedNodes })
  }
  onSave = () => {
    this.setState({ saving: true })
    this.props.updateGraphNodes(this.state.updatedNodes)
      .then(() => this.setState({
        saving: false,
        updatedNodes: {}
      }))
  }
  onReset = () => {
    this.setState({ updatedNodes: {} })
  }
  showResolveIndicator = node => {
    return !node.discover__updated_at
  }
  render () {
    return (
      <div className={classNames.page}>
        <p className={classNames.note}>
          First input: <strong>weight</strong>
          <br />
          Second input: <strong>weight-group</strong>
          <br />
          <ExamplePercentage />: The chance of a node being selected when traversing the graph
          <br />
          <ExamplePercentageGroup />: The change of a node being selected for use in a generated album
        </p>
        <KeywordGraphPicker
          value={this.state.updatedNodes}
          onChange={this.updateNodes}
          showUpdatedTime='discover__updated_at'
          showResolveIndicator={this.showResolveIndicator}
          onClickResolve={this.props.touchNodeWeighting}
          showIndicators
          showWeighting
          headerButtons={[
            <button
              key='reset'
              onClick={this.onReset}
              className={classNames.resetButton}>
              Reset Changes
            </button>,
            <button
              key='save'
              onClick={this.onSave}
              className={classNames.saveButton}
              disabled={this.state.saving}>
              {this.state.saving ? 'Saving…' : 'Save'}
            </button>
          ]}
        />
      </div>
    )
  }
}

const mapStateToProps = ({ config }) => ({
})

const mapDispatchToProps = {
  updateGraphNodes,
  touchNodeWeighting
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdateKeywordWeighting)



// WEBPACK FOOTER //
// ./src/pages/UpdateKeywordWeighting.js